import { keyBy, startCase } from 'lodash/fp';

import {
  fieldPathHasValidSchema,
  WorkflowValidationContext,
} from 'dashboard/lib/workflows/validation/validationContext';
import { WorkflowConfigError, WorkflowErrorType } from 'dashboard/models/workflow';
import { BlockInput } from 'dashboard/models/workflow-block';
import { WorkflowStepModule } from 'dashboard/models/workflow-version';

export const validateModuleStep = (
  step: WorkflowStepModule,
  validationContext: WorkflowValidationContext,
  blockInputs: BlockInput[] = [],
): WorkflowConfigError[] => {
  if (!step['child-workflow-block-id']) {
    return [
      {
        field: 'child-workflow-block-id',
        token: step.token,
        message: 'Module must be selected',
        type: WorkflowErrorType.Save,
      },
    ];
  }

  const stepContext = validationContext.getContextForStep(step.token);
  const inputMappingsByToken = keyBy('input-token', step['input-mappings']);
  return blockInputs
    .map<WorkflowConfigError | null>(({ token, required, name }) => {
      const mapping = inputMappingsByToken[token];
      if (
        required &&
        !mapping?.['method-chain'] &&
        mapping?.['raw-value'] !== false &&
        !mapping?.['raw-value']
      ) {
        return {
          field: `input-mappings.${token}`,
          token: step.token,
          message: `${startCase(name)} is required`,
          type: WorkflowErrorType.Publish,
        };
      }

      if (mapping?.['method-chain']) {
        const { valid, errorMessages } = fieldPathHasValidSchema(
          mapping['method-chain'],
          stepContext,
          validationContext,
        );
        if (!valid) {
          return {
            field: `input-mappings.${token}`,
            token: step.token,
            message: `Invalid path: ${errorMessages.join(', ')}`,
            type: WorkflowErrorType.Publish,
          };
        }
      }

      return null;
    })
    .filter((e): e is WorkflowConfigError => e != null);
};
